<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter_4">
<a id="page_20"></a>
<h1 class="chtitle"><a href="#/text/9780062192523_Contents#Chapter_4"><img alt="image" class="epubimage" src="images/ch04.jpg"/></a></h1>
<p class="noIndent"><span class="dp">B</span>ay Academy Prep was situated on a sprawling campus with a duck pond. You had to drive through a gate and up over a hill past the pond—which was home to a few cute ducks and more than a few big, dirty seagulls—until you arrived at the main building, which resembled a red sandstone cathedral. It was listed as a San Francisco landmark. It had been very impressive to the Walkers at first, but now it was just school.</p>
<p>The Walkers gave one another fist bumps and went their separate ways.</p>
<p>Eleanor headed left, down a path where she was joined by other kids her age. The third graders had two forces acting on their bodies as they walked to class—the weight of their backpacks, which pulled them back, and their desire to play with their phones, which hunched them forward. Eleanor texted her mom on her starter phone as she walked in. There wasn’t much else she could do on the phone, since it couldn’t go on the internet. Eleanor didn’t mind; she was just happy to be able to text her mom when she needed her.</p>
<a id="page_21"></a>
<p class="image"><img alt="image" class="epubimage" src="images/p22.jpg"/></p>
<div class="blockquote">
<p class="bq1"><em class="i">I miss you mom</em></p>
<p class="bq1a"><em class="i">Is everything okay?</em></p>
</div>
<a id="page_22"></a>
<p class="spacebreak">Before Eleanor could answer, she realized that two girls were walking beside her, one on either side: Zoe and Ruby. Not the nicest girls. Both taller than Eleanor, and (she had to admit) prettier. <em class="i">But they’ve each got models as moms—what are they supposed to be, short and ugly?</em></p>
<p>“Hey, Ruby, did you see what I posted last night?” Zoe asked, speaking right across Eleanor as if she weren’t there.</p>
<p>“Oh yeah!” Ruby said. “It’s awesome! And did you see? I just Instagrammed the funniest picture of my French bulldog.”</p>
<p>Ruby held out her phone directly across Eleanor’s face, so Zoe could see the photo. Eleanor realized they were showing off their phones.</p>
<p>“I know what you’re doing,” Eleanor said, rolling her eyes. “You don’t have to be so obvious. I know my phone’s not as good as yours.”</p>
<p>Ruby looked at Eleanor like she was surprised to see her there. “We’re not doing anything. We were just talking.”</p>
<p>“You think you can make me feel bad, but you can’t. I’ve done a lot of amazing stuff that you would never ever understand. I’ve taken down a real witch.”</p>
<p>“A <em class="i">real</em> <em class="i">witch</em>?” asked Zoe.</p>
<p>“What are you talking about?” said Ruby. “You got in a fight with Ms. Carter?” There was a rumor going around school that Ms. Carter, who had dreadlocks and a skull tattoo, was actually a witch.</p>
<a id="page_23"></a>
<p>“No, I—” Eleanor started to explain, but then realized that if she told them any more of the story, she would sound completely bananas. So she just muttered under her breath: “Forget it.”</p>
<p>Ruby put a hand on her shoulder. “You need to calm down. You’re not, like, so important that we just gang up on you to make fun of you.”</p>
<p>“Really?”</p>
<p>“Yeah,” Zoe said. “But you should probably get something better than a grandpa phone.”</p>
<p>Ruby laughed, just a little, and the two girls breezed past Eleanor into school. Eleanor’s head was spinning. She looked back at her phone, at the question “<em class="i">Is everything okay?</em>”</p>
<p>She wanted to get into how Cordelia was mean on the ride over, and how they’d run into Dad and he looked terrible, and how these two girls were making fun of her and she almost spilled the beans about the Wind Witch, and how she just wanted things to go back to normal, the way they were before . . . but instead she wrote to her mom:</p>
<div class="blockquote">
<p class="bq1"><em class="i">Everything’s fine</em></p>
</div>
<p>She had a feeling that was the way grown-ups handled it.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062192523_Chapter_4.vue?601e3ec7